import { WorkspacePermissionService } from '@affine/core/modules/permissions';
import { canCreateDocFromCachedWorkspaceRole } from '@affine/core/modules/permissions/utils/workspace-create-doc';
import { WorkspaceService } from '@affine/core/modules/workspace';
import { useLiveData, useService } from '@toeverything/infra';

import { useGuard } from './use-guard';

export function useWorkspaceCreateDocPermission() {
  const workspace = useService(WorkspaceService).workspace;
  const permissionService = useService(WorkspacePermissionService);
  const canCreateDoc = useGuard('Workspace_CreateDoc');
  const workspaceRole = useLiveData(permissionService.permission.role$);
  const effectiveWorkspaceRole = workspaceRole ?? workspace.meta.role ?? null;
  const canCreateDocFromLocalRole =
    workspace.flavour !== 'local' &&
    canCreateDocFromCachedWorkspaceRole(effectiveWorkspaceRole);

  return {
    canCreateDoc,
    canCreateDocFromLocalRole,
    canCreateDocEffective:
      canCreateDoc === true ||
      (canCreateDoc !== false && canCreateDocFromLocalRole),
  };
}
